import { render, staticRenderFns } from "./TypePanel.vue?vue&type=template&id=15e5f0e8&scoped=true"
import script from "./TypePanel.vue?vue&type=script&lang=js"
export * from "./TypePanel.vue?vue&type=script&lang=js"
import style0 from "./TypePanel.vue?vue&type=style&index=0&id=15e5f0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5f0e8",
  null
  
)

export default component.exports